import React from "react";

export default function EnergySection({ data, onOpenContact }) {
  return (
    <section className="energy-mgmt-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 wow animate__animated animate__slideInLeft"
            data-wow-delay="0.1s"   data-wow-duration="2s" >
            <span className="main-title">{data.eyebrow}</span>
            <h2 className="heading">{data.title}</h2>
            {data.paragraphs.map((paragraph) => (
              <p key={paragraph.text}>
                {paragraph.bold ? <div className="bold-text">{paragraph.text}</div> : paragraph.text}
              </p>
            ))}
            <button type="button" onClick={onOpenContact} className="default-btn">
              {data.button}
            </button>
          </div>
          <div className="col-lg-6 wow animate__animated animate__slideInRight"  data-wow-delay="0.1s"  data-wow-duration="2s" >
            <img src={data.image} alt={data.imageAlt} className="img-responsive" />
          </div>
        </div>
      </div>
    </section>
  );
}
